<template>
  <v-dialog v-model="dOpenModal" persistent width="800px">
    <!--Cabecera-->
    <v-card>
      <v-card-title class="data-bgPrimaryColor white--text data-headerModal">
        <div>
          <v-flex xs10 pl-2>
            <span class="data-title">{{ this.$t('usuarios') }}</span>
          </v-flex>
          <v-flex xs2 class="iconClose">
            <v-btn class="close" flat icon color="white" @click="$emit('close')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </div>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>

          <v-progress-circular v-if="dDescargando" :size="50" color="primary" indeterminate>
          </v-progress-circular>
          <v-flex xs4 ml-auto>
            <v-text-field v-model="dSearch" append-icon="search" label="Search" single-line hide-details
              class="pb-2"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-data-table v-if="!dDescargando" :headers="dHeaders" :items="dUsersERP" :search="dSearch"
              :pagination.sync="dPaginationUser" class="mt-1 mb-4">
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <v-checkbox v-model="props.selected" color="datSecondary" hide-details
                    @change="fChangeSelectedItem(props, item)"></v-checkbox>

                </td>
                <td class="text-xs-left">{{ props.item.rn }}</td>
                <td class="text-xs-left">{{ props.item.nombre }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="py-3 transparent">
        <v-flex xs12 pr-3 class="text-xs-right">
          <v-btn :disabled="dDescargando" class="datPrimaryBtn" flat @click="fAnyadirUsuario()">
            {{ this.$t('anyadir') }}
          </v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SrvUsers from '@/services/srv-users'

export default {
  name: 'ShpAdministracionNuevoUsuario',
  props: {
    dOpenModal: {
      type: Boolean,
      require: true,
      default: false
    }
  },
  data() {
    return {
      dSearch: '',
      dHeaders: [
        {
          text: 'Seleccionar'
        },
        {
          text: 'Codigo',
          value: 'rn',
          sortable: true
        },
        {
          text: 'Nombre',
          value: 'nombre'
        }
      ],
      dUsers: [],
      dUsersERP: [],
      dUsersInformes: [],
      dPaginationUser: { 'sortBy': 'rn', 'descending': false, 'rowsPerPage': 7 },
      dSelectedUsers: [],
      dDescargando: false
    }
  },
  mounted() {
    this.fObtenerUsuariosERP()
  },
  methods: {
    // ERP
    fObtenerUsuariosERP() {
      SrvUsers.getUsers(localStorage.getItem('datos-autenticacion').tira).then(response => {
        this.dUsersERP = response.data.dataRes
        this.fObtenerUsuariosInformes()
      })
    },
    // INFORMES
    fObtenerUsuariosInformes() {
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        idOrganizacion: this.$store.getters.getAutenticacion.organizacion,
        search: '',
        offset: 1,
        numRows: 9999,
        orderBy: 'usuario',
        order: 'ASC',
        filters: []
      }
      SrvUsers.getUsersInformes(payload).then(response => {
        this.dUsersInformes = response.data.result
        this.fFiltrarUsuarios()
      })
    },
    fFiltrarUsuarios() {
      // Añadimos en dUsers los usuarios que estén en dUsersERP que no estén en dUsersInformes
      const usersAux = []
      this.dUsersERP.forEach(elementERP => {
        if (this.dUsersInformes.find(elementInformes => elementInformes.usuario === elementERP.usuario) === null) {
          usersAux.push(elementERP)
        }
      })
      this.dUsers = usersAux
      this.dDescargando = false
    },
    fAnyadirUsuario() {
      this.dDescargando = true
      // Rellenar promise
      const promesas = []
      this.dSelectedUsers.forEach(element => {
        const promise = new Promise((resolve, reject) => {
          const payload = {
            idOrganizacion: element.idOrganizacion,
            login: element.usuario,
            usuario: -1,
            nombre: element.nombre,
            email: element.email,
            telefono: element.telefono
          }
          SrvUsers.creaUsuarioSP(payload)
        })
        promesas.push(promise)
      })
      Promise.all(promesas).then(() => {
        this.dDescargando = false
      })
      this.fObtenerUsuariosERP()
      this.$parent.$parent.cargaUsuarios('usuario', 'ASC', 1, undefined, '', undefined)
    },
    fChangeSelectedItem(props, item) {
      props.selected = true
      if (props != null) {
        if (!this.dSelectedUsers.includes(props.item)) {
          this.dSelectedUsers.push(props.item)
        } else {
          const element = this.dSelectedUsers.find(element => element === props.item)
          const index = this.dSelectedUsers.indexOf(element)
          this.dSelectedUsers.splice(index, 1)
        }
      }
    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/Administracion/ShpAdministracionNuevoUsuario.vue